import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
/* eslint-disable quotes */
import { createTheme, alpha } from '@mui/material/styles';
import { PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_TEXT, PROMETHEAN_MID_PURPLE } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04 } from '../styles/typography/typography';
import { prometheanFont } from '../styles/font/font';
export var ROOT_PREFIX = 'EmbersRadio';
var uncheckedSvgPath = {
  d: "path('M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z')",
  fillRule: 'evenodd',
  clipRule: 'evenodd'
};
var checkedSvgPath = {
  d: "path('M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z')",
  fillRule: 'evenodd',
  clipRule: 'evenodd'
};
export var createRadioTheme = function createRadioTheme() {
  return createTheme({
    components: {
      MuiRadio: {
        styleOverrides: {
          root: {
            fontFamily: prometheanFont,
            color: PROMETHEAN_TEXT,
            padding: 5,
            svg: {
              path: _objectSpread(_objectSpread({}, uncheckedSvgPath), {}, {
                fill: PROMETHEAN_TEXT
              })
            },
            '&+.MuiTypography-root': _objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY),
            '&:hover': {
              backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
              boxShadow: "0 0 0 1px ".concat(PROMETHEAN_MID_PURPLE),
              // not on touch devices
              '@media (hover: none)': {
                backgroundColor: 'transparent',
                boxShadow: 'none'
              }
            },
            '&:active': {
              backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.3),
              boxShadow: "0 0 0 1px ".concat(PROMETHEAN_MID_PURPLE)
            },
            '&.Mui-disabled': {
              svg: {
                path: _objectSpread(_objectSpread({}, uncheckedSvgPath), {}, {
                  fill: PROMETHEAN_NEUTRAL_DARK_GREY
                })
              }
            },
            '&.EmbersRadio-hybridDeviceHover': {
              '&:hover': {
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
                boxShadow: "0 0 0 1px ".concat(PROMETHEAN_MID_PURPLE)
              },
              '&:active': {
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.3),
                boxShadow: "0 0 0 1px ".concat(PROMETHEAN_MID_PURPLE)
              }
            },
            '&.Mui-checked': {
              color: PROMETHEAN_PURPLE_GRAPE,
              svg: {
                path: _objectSpread(_objectSpread({}, checkedSvgPath), {}, {
                  fill: PROMETHEAN_PURPLE_GRAPE
                })
              },
              '&:hover': {
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
                boxShadow: "0 0 0 1px ".concat(PROMETHEAN_PURPLE_GRAPE),
                // not on touch devices
                '@media (hover: none)': {
                  backgroundColor: 'transparent',
                  boxShadow: 'none'
                }
              },
              '&:active': {
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.3),
                boxShadow: "0 0 0 1px ".concat(PROMETHEAN_PURPLE_GRAPE)
              },
              '&.EmbersRadio-hybridDeviceHover': {
                '&:hover': {
                  backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
                  boxShadow: "0 0 0 1px ".concat(PROMETHEAN_PURPLE_GRAPE)
                },
                '&:active': {
                  backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.3),
                  boxShadow: "0 0 0 1px ".concat(PROMETHEAN_PURPLE_GRAPE)
                }
              },
              '&.Mui-disabled': {
                svg: {
                  path: _objectSpread(_objectSpread({}, checkedSvgPath), {}, {
                    fill: PROMETHEAN_NEUTRAL_DARK_GREY
                  })
                }
              }
            }
          }
        }
      },
      MuiFormGroup: {
        styleOverrides: {
          root: {
            marginTop: -8,
            marginBottom: -8,
            '&.MuiFormGroup-row': {
              '>.MuiFormControlLabel-root': {
                marginRight: 16
              }
            },
            '&:not(.MuiFormGroup-row)': {
              '.MuiFormControlLabel-root:not(:first-of-type), .EmbersLabeledBox:not(:first-of-type)': {
                marginTop: -2
              }
            }
          }
        }
      },
      MuiFormLabel: {
        styleOverrides: {
          root: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
            marginBottom: 11,
            '&.Mui-focused': {
              color: PROMETHEAN_TEXT
            }
          })
        }
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            margin: '5px 0 5px 3px',
            padding: '0 !important'
          }
        }
      }
    }
  });
};